// eslint-disable-next-line
import React, { useEffect, useState } from 'react';
import summaryApi from '../common/Api';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import DisplayCategoryWiseProduct from '../components/DisplayCategoryWiseProduct/DisplayCategoryWiseProduct';
import Loading from '../components/loading/loading';

const SearchCart = () => {
  const [query,setQuery] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // Extract query parameter from URL search string
  const searchQuery = new URLSearchParams(location.search).get('query');
//   console.log("Search Query from URL:", searchQuery);

  const fetchSearch = async (searchQuery) => {
    setLoading(true);
    try {
      if (!searchQuery.trim()) {
        console.warn("No search query provided.");
        return;
      }

      // Construct the URL for the API request
      const encodedQuery = encodeURIComponent(searchQuery.trim());
      const response = await axios.get(`${summaryApi.SearchCartProduct.url}${encodedQuery}`);

      setData(response.data.data); // Store fetched products in state
    //   console.log("Search Results:", response.data.data);
    
    } catch (error) {
      console.error("Error fetching search results:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchQuery) {
      setQuery(searchQuery); // Store the query in the state
      fetchSearch(searchQuery); // Trigger search when component mounts or searchQuery changes
    }
  }, [searchQuery]); // Run effect when searchQuery changes

  if(loading) {
    return <div> <Loading /> </div>;
  }

  return (
    <>
      <div className='container mx-auto p-4'>

        <h2 className='font-bold py-4 text-xl'>Search Result: {data.length} </h2>

              <DisplayCategoryWiseProduct  filterSearch={data} />

      </div>
    </>
  );
};

export default SearchCart;
